import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ToastController, LoadingController, AlertController } from '@ionic/angular';
import { Router } from '@angular/router';
import { HelperService } from 'src/app/core/services/helper.service';
import { Storage } from '@ionic/storage';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import _ from 'lodash';
import { PostmanuiComponent } from 'src/app/shared/components/postmanui/postmanui.component';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-api-catalog-create',
  templateUrl: './api-catalog-create.component.html',
  styleUrls: ['./api-catalog-create.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ApiCatalogCreateComponent implements OnInit {

  apiCatalogFormType: any = 'source';
  @ViewChildren(PostmanuiComponent) postmanuiComponents!: QueryList<PostmanuiComponent>;

  @ViewChild('apiImage') apiImage: ElementRef;

  apiCatalogList = [
    {
      label: 'API Catalog',
      embedurl: true,
      url: '/baseapp/api-catalog/view'
    },
    {
      label: 'Create',
      embedurl: false,
      url: ''
    }
  ];

  loader: boolean = true;
  userIp: any;
  hide1200 = false;
  bubbleShow: boolean = false;
  brand: boolean = false;
  product: boolean = false;
  chooseType: boolean = false;
  commerce: boolean = false;
  priceDeals: boolean = false;
  businessObj: boolean = false;
  workflowStatus: boolean = false;
  description: boolean = false;
  apiImagePath: SafeUrl = "../assets/images/upload_image_placeholder.svg";
  apiImageExists: boolean = false;
  updateApiImage: boolean = false;
  isEnableImageChanges: boolean = false;
  selectedFileBlob: any;
  addApiCatalog: any;

  categoryList: any;
  brandsList: any;
  productList: any;
  typeList: any;
  priceDealsList: any;
  workflowList: any;

  apiCatalogForm: UntypedFormGroup;
  apiSourceName = "bizdata_rest";
  
  constructor(
    private backendService: BackendService,
    public breakpointObserver: BreakpointObserver,
    private formBuilder: UntypedFormBuilder,
    public toastController: ToastController,
    public loadingController: LoadingController,
    public alertController: AlertController,
    private router: Router,
    public helperService: HelperService,
    public storage: Storage,
    private sanitizer: DomSanitizer
  ) { }

  async ngOnInit() {
    await this.helperService.loader();
    this.initializeNavHelper();
    this.getUserIp();
    this.initializeForm();
    this.observeScreenSize();
    this.setBubbleVisibility();
    await this.initializeApiData();

    await this.helperService.closeLoader();
  }
  
  private initializeNavHelper(): void {
    this.helperService.getNavHelp().subscribe(
      toggle => {
        if (toggle) {
          this.closeBubbleCross();
        }
      },
      error => console.error('Error fetching navigation help:', error)
    );
  }

  private getUserIp() {
    this.backendService.getUserIp().subscribe(
      (data) => {
        const e: any = data as any;
        //console.log(e);
        this.userIp = e.ip;
      })
  }
  
  private initializeForm(): void {
    this.apiCatalogForm = this.formBuilder.group({
      api_category: ['', Validators.required],
      api_brand: ['', Validators.required],
      api_price: ['', Validators.required],
      api_type: ['', Validators.required],
      api_commerce: ['', Validators.required],
      api_product_name: ['', Validators.required],
      api_business_object: ['', Validators.required],
      api_description: ['', Validators.required],
      workflow_status: ['', Validators.required]
    });
  }
  
  private observeScreenSize(): void {
    this.breakpointObserver.observe(['(min-width: 1200px)']).subscribe(
      (state: BreakpointState) => {
        this.hide1200 = state.matches;
      },
      error => console.error('Error observing screen size:', error)
    );
  }

  async getStorage() {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id"),
      showDialog: await this.storage.get("showDialog")
    }
    return data;
  }

  initializeApiData(): Promise<void> {
    return new Promise(async (resolve, reject) => {
      try {
        const storageResponse = await this.getStorage();
        const token = storageResponse.token;
        const payload = { min: "", max: "" };
  
        forkJoin({
          categories: this.backendService.PostAPICall('getAllCategories', payload, token),
          priceDeals: this.backendService.GetAPICall('getPrice', token),
          workflowStatus: this.backendService.GetAPICall('getWorkflowStatus', token),
          types: this.backendService.GetAPICall('getType', token),
        }).subscribe({
          next: ({ categories, priceDeals, workflowStatus, types }) => {
            this.categoryList = categories?.records;
            this.helperService.sortArr(this.categoryList, 'category');
            this.priceDealsList = priceDeals;
            this.workflowList = workflowStatus;
            this.typeList = types;
            resolve();
          },
          error: (err) => {
            console.error("Error in fetching API data:", err);
            reject(err);
          }
        });
  
      } catch (err) {
        console.error("Error fetching token from storage:", err);
        reject(err);
      }
    });
  }

  private async setBubbleVisibility() {
    try {
      const storageData = await this.getStorage();
      const token = storageData.token;
      
      this.bubbleShow = storageData.showDialog === 1;
    } catch (error) {
      console.error('Error in setBubbleVisibility:', error);
    } finally {
      this.loader = false;
    }
  }

  closeBubbleCross() {
    this.bubbleShow = false;
    this.brand = false;
    this.product = false;
    this.chooseType = false;
    this.commerce = false;
    this.priceDeals = false;
    this.businessObj = false;
    this.workflowStatus = false;
    this.description = false;
    this.updateApiImage = false;
    this.addApiCatalog = false;
  }

  closeBubble() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.bubbleShow = false;
        this.brand = true;
      }
    });
  }

  closeBrand() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.brand = false;
        this.product = true;
      }
    });
  }

  closeProduct() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.product = false;
        this.chooseType = true;
      }
    });
  }

  closeType() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.chooseType = false;
        this.commerce = true;
      }
    });
  }

  closeCommerce() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.commerce = false;
        this.priceDeals = true;
      }
    });
  }

  closePrice() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.priceDeals = false;
        this.businessObj = true;
      }
    });
  }

  closeBusinessObj() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.businessObj = false;
        this.workflowStatus = true;
      }
    });
  }

  closeWorkflowStatus() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.workflowStatus = false;
        this.description = true;
      }
    });
  }

  closeDescription() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.description = false;
        this.updateApiImage = true;
      }
    });
  }

  closeUpdateImage() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.updateApiImage = false;
        this.addApiCatalog = true;
      }
    });
  }

  closeAddApiCatalog() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.addApiCatalog = false;
      }
    });
  }

  onChangeGetBrands(event) {
    this.closeBubbleCross();
    this.brandsList = [];
    let brandValue = { ID: event.value.id };
    this.getStorage().then((res) => {
      this.backendService.PostAPICall('getBrandsByCatId', brandValue, res.token)
        .subscribe(
          data => {
            { this.brandsList = data.records }

            if (data) {
              this.brandsList = data;
              this.helperService.sortArr(this.brandsList, 'brand_name');
            } else {
              this.brandsList = [];
            }
          },
          error => {
            //console.log(error);
            this.helperService.handleError(error);
          }
        )
      }
    )
    this.closeBubble();
  }

  onChangeGetProduct(event) {
    this.closeBubbleCross();
    this.productList = [];
    let productValue = { ID: event.value.id };
    this.getStorage().then((res) => {
      this.backendService.PostAPICall('getProductsByBrandId', productValue, res.token)
        .subscribe(
          data => {
            if (data) {
              this.productList = data;
              this.helperService.sortArr(this.productList, 'product_name');
            } else {
              this.productList = [];
            }
          },
          error => {
            //console.log(error);
            this.helperService.handleError(error);
          }
        )
      }
    )
    this.closeBrand();
  }

  onChangeGetType() {
    this.closeBubbleCross();
    this.closeProduct();
  }

  onChangeGetCommerce(event) {
    this.apiCatalogFormType = event.value.type === 'Data Source' ? 'source' : 'target';
    this.closeBubbleCross();
    this.closeType();
  }

  onChangeCommerce() {
    this.closeBubbleCross();
    this.closeCommerce();
  }

  onChangeGetPrice() {
    this.closeBubbleCross();
    this.closePrice();
  }

  onChangeBusinessObj() {
    this.closeBubbleCross();
    this.closeBusinessObj();
  }

  onChangeWorkflow() {
    this.closeBubbleCross();
    this.closeWorkflowStatus();
  }

  onChangeDescription() {
    this.closeBubbleCross();
    this.closeDescription();
  }

  uploadImage(event: any) {
    if (event.target.files && event.target.files[0]) {
      // Check if the image type is 'image'
      const imageType = event.target.files[0].type.split('/')[0];
      if (imageType === 'image') {
        // Check the image size is within the limit
        const maxImageSize = 100000; // bytes
        this.selectedFileBlob = event.target.files[0];
        if (event.target.files[0].size > maxImageSize) {
          this.apiImage.nativeElement.value = '';
          this.helperService.presentToast(`Max image upload size is ${maxImageSize / 1000}KB only`, 3000);
          return;
        }
        // Check the image dimensions are within the limit
        const maxImageDimension = 400; // pixels
        const img = new Image();
        this.apiImageExists = true;
        const reader = new FileReader();
        reader.onload = (event: any) => {
          img.onload = () => {
            if (img.width !== maxImageDimension || img.height !== maxImageDimension) {
              this.apiImage.nativeElement.value = '';
              this.helperService.presentToast(`Image size should be ${maxImageDimension} x ${maxImageDimension}`, 3000);
              return;
            }
            this.isEnableImageChanges = true;
            this.apiImagePath = this.sanitizer.bypassSecurityTrustResourceUrl(event.target.result);
          };
          img.src = event.target.result;
        };
        reader.onerror = (error: any) => {
          this.helperService.presentToast('Error reading the image file', 3000);
        };
        reader.readAsDataURL(event.target.files[0]);
      } else {
        this.apiImage.nativeElement.value = '';
        this.helperService.presentToast('Invalid image type. Only images are allowed.', 3000);
      }
    }
    this.closeUpdateImage();
  }

  addNewImage(catId) {
    this.getStorage().then((res) => {
      const payload = new FormData();
      const method = 'post';
      payload.append('catalogImage', this.selectedFileBlob);
      payload.append('id', catId);
      this.backendService.fileUpload('saveCatalogImage', method, payload, res.token).subscribe(
        (data) => {
          // this.helperService.closeLoader();
          // this.helperService.presentToast(data.msg, 2000);
          // this.router.navigate(['/baseapp/organization']);
        },
        (error) => {
          //console.log(error);
           this.helperService.handleError(error);
           this.helperService.closeLoader();
        }
      );
    })
  }

  clearImage() {
    this.apiImage.nativeElement.value = '';
    this.isEnableImageChanges = false;
    this.apiImagePath = "../assets/images/upload_image_placeholder.svg";
    this.apiImageExists = false;
  }

  get apiCatalogControls() {
    return this.apiCatalogForm.controls; 
  }

  async onSubmitApiCatalog() {
    if (this.apiCatalogForm.invalid) {
      this.helperService.presentToast("Form incomplete", 2000);
      return;
    }

    if (!this.apiImageExists) {
      this.helperService.presentAlert("Alert!", "Image is not selected, please select image");
      return;
    }

    let selectedPayload;
    let sourcePostmanFormData;
    let targetPostmanFormData;
    for (let component of this.postmanuiComponents.toArray()) {
      let postmanFormData = await component.getApiCatalogPostmanData();
      if(component.apiCatalogFormType === 'source' 
        && !postmanFormData.sourcePostmanFormInvalid) {
        sourcePostmanFormData = postmanFormData;
        selectedPayload = {
          selectedEnvironment      : sourcePostmanFormData.sourceSelectedEnvironment,
          environmentList          : sourcePostmanFormData.sourceEnvironmentList,
          environmentData          : sourcePostmanFormData.sourceEnvironmentData,
          endpointMethod           : sourcePostmanFormData.sourceEndpointMethod,
          apiEndpointUrl           : sourcePostmanFormData.sourceApiEndpointUrl,
          paramsData               : sourcePostmanFormData.sourceParamsData,
          headersData              : sourcePostmanFormData.sourceHeadersData,
          authType                 : sourcePostmanFormData.sourceAuthType,
          authUsername             : sourcePostmanFormData.sourceAuthUsername,
          authPassword             : sourcePostmanFormData.sourceAuthPassword,
          authRtemethod            : sourcePostmanFormData.sourceAuthRtemethod,
          authRteurl               : sourcePostmanFormData.sourceAuthRteurl,
          authRteheaders           : sourcePostmanFormData.sourceAuthRteheaders,
          authRteparams            : sourcePostmanFormData.sourceAuthRteparams,
          authRtebody              : sourcePostmanFormData.sourceAuthRtebody,
          endpointBodyType         : sourcePostmanFormData.sourceEndpointBodyType,
          endpointBodyData         : sourcePostmanFormData.sourceEndpointBodyData,
          preRequestScript         : sourcePostmanFormData.sourcePreRequestScript,
          selectPaginationType     : sourcePostmanFormData.sourceSelectPaginationType,
          userKey                  : sourcePostmanFormData.sourceUserKey,
          responseParameters       : sourcePostmanFormData.sourceResponseParameters,
          paginationRetrySeconds   : sourcePostmanFormData.sourcePaginationRetrySeconds,
          anotherResponseParameter : sourcePostmanFormData.sourceAnotherResponseParameter,
          keyNameToUpdate          : sourcePostmanFormData.sourceKeyNameToUpdate,
          userKeyUrl               : sourcePostmanFormData.sourceUserKeyUrl,
          customPaginationScript   : sourcePostmanFormData.sourceCustomPaginationScript,
          minNum                   : sourcePostmanFormData.sourceMinNum,
          maxNum                   : sourcePostmanFormData.sourceMaxNum,
          todayStr                 : sourcePostmanFormData.sourceTodayStr,
          yesterdayStr             : sourcePostmanFormData.sourceYesterdayStr,
          rollingTimeFormat        : sourcePostmanFormData.sourceRollingTimeFormat,
          rollingFrequency         : sourcePostmanFormData.sourceRollingFrequency,
          offsetValue              : sourcePostmanFormData.sourceOffsetValue,
          responseType             : sourcePostmanFormData.sourceResponseType
        }
      } else if(component.apiCatalogFormType === 'target' 
        && !postmanFormData.targetPostmanFormInvalid) {
        targetPostmanFormData = postmanFormData;
        selectedPayload = {
          selectedEnvironment      : targetPostmanFormData.targetSelectedEnvironment,
          environmentList          : targetPostmanFormData.targetEnvironmentList,
          environmentData          : targetPostmanFormData.targetEnvironmentData,
          endpointMethod           : targetPostmanFormData.targetEndpointMethod,
          apiEndpointUrl           : targetPostmanFormData.targetApiEndpointUrl,
          paramsData               : targetPostmanFormData.targetParamsData,
          headersData              : targetPostmanFormData.targetHeadersData,
          authType                 : targetPostmanFormData.targetAuthType,
          authUsername             : targetPostmanFormData.targetAuthUsername,
          authPassword             : targetPostmanFormData.targetAuthPassword,
          authRtemethod            : targetPostmanFormData.targetAuthRtemethod,
          authRteurl               : targetPostmanFormData.targetAuthRteurl,
          authRteheaders           : targetPostmanFormData.targetAuthRteheaders,
          authRteparams            : targetPostmanFormData.targetAuthRteparams,
          authRtebody              : targetPostmanFormData.targetAuthRtebody,
          endpointBodyType         : targetPostmanFormData.targetEndpointBodyType,
          endpointBodyData         : targetPostmanFormData.targetEndpointBodyData,
          preRequestScript         : targetPostmanFormData.targetPreRequestScript,
          selectPaginationType     : "",
          userKey                  : "",
          responseParameters       : "",
          paginationRetrySeconds   : "",
          anotherResponseParameter : "",
          keyNameToUpdate          : "",
          userKeyUrl               : "",
          customPaginationScript   : "",
          minNum                   : "",
          maxNum                   : "",
          todayStr                 : "",
          yesterdayStr             : "",
          rollingTimeFormat        : "",
          rollingFrequency         : "",
          offsetValue              : "",
          responseType             : targetPostmanFormData.targetResponseType
        }
      }
    }

    if (!selectedPayload) {
      console.log("No valid Postman form data found");
      return;
    }

    this.getStorage().then((res) => {
      let payload = {
        'api_category': this.apiCatalogForm.value.api_category.id,
        'api_brand': this.apiCatalogForm.value.api_brand.id,
        'api_price': this.apiCatalogForm.value.api_price.id,
        'api_type': this.apiCatalogForm.value.api_type.id,
        'api_commerce': this.apiCatalogForm.value.api_commerce,
        'api_product_name': this.apiCatalogForm.value.api_product_name,
        'api_business_object': this.apiCatalogForm.value.api_business_object,
        'created_by': res.userId,
        "create_ip_address": this.userIp,
        'api_source_name': this.apiSourceName,
        'api_object_keyword': "",
        'api_description': this.apiCatalogForm.value.api_description,
        'workflow_status': this.apiCatalogForm.value.workflow_status.status_code,
        'filter_type': "",
        'parameter1': "",
        'parameter2': "",
        'parameter3': "",
        'parameter4': "",
        // "min_num": this.apiCatalogForm.value.min_number,
        // "max_num": this.apiCatalogForm.value.max_number,
        'api_input_structure': {
          'endpoint_url': selectedPayload.apiEndpointUrl,
          'endpoint_method': selectedPayload.endpointMethod,
          'endpoint_params_raw': selectedPayload.paramsData,
          'authentication_type': selectedPayload.authType,
          'authentication_token': '',
          'username': selectedPayload.authUsername,
          'password': selectedPayload.authPassword,
          'refresh_token_endpoint_method': selectedPayload.authRtemethod,
          'refresh_token_endpoint_url': selectedPayload.authRteurl,
          'refresh_token_endpoint_header': selectedPayload.authRteheaders,
          'refresh_token_endpoint_params': selectedPayload.authRteparams,
          'refresh_token_endpoint_body': selectedPayload.authRtebody,
          'endpoint_headers': selectedPayload.headersData,
          
          'body_type': selectedPayload.endpointBodyType,
          'endpoint_body_raw': selectedPayload.endpointBodyData,
          'pre_request_script': selectedPayload.preRequestScript,
          "pagination": {
            "pagination_style": selectedPayload.selectPaginationType,
            "user_key_url": selectedPayload.userKeyUrl,
            "response_parameters": selectedPayload.responseParameters,
            "user_key": selectedPayload.userKey,
            "key_name_to_update": selectedPayload.keyNameToUpdate,
            "another_response_parameter": selectedPayload.anotherResponseParameter,
            "custom_pagination_script": selectedPayload.customPaginationScript,
            "min_num": selectedPayload.minNum,
            "max_num": selectedPayload.maxNum,
          },
          'time_params': {
            "today_str": selectedPayload.todayStr,
            "yesterday_str": selectedPayload.yesterdayStr,
            "rolling_time_format": selectedPayload.rollingTimeFormat,
            "rolling_frequency": selectedPayload.rollingFrequency,
            "offset_value": selectedPayload.offsetValue
          }
        },
        "environment_name": selectedPayload.selectedEnvironment,
        "environment_variables": selectedPayload.environmentList,
        "response_type": selectedPayload.responseType
      };
      //console.log(payload);
      
      this.getStorage().then(async (res) => {
        await this.helperService.loader();
        this.backendService.PostAPICall('createApiCatalogue', payload, res.token)
          .subscribe(
            data => {
              //console.log(data)
              this.addNewImage(data.id);
              this.helperService.presentToast(data.msg, 2000);
              // this.apiCatalogForm.reset();
              this.helperService.closeLoader()
              //.then(() => {
              this.router.navigate(['/baseapp/api-catalog/view']);
              // });
            },
            error => {
              this.helperService.closeLoader();
              this.helperService.handleError(error);
            })
      })
    })
  }

}

